import {StateCreator} from "zustand/vanilla";
import {companyTrendsAPI} from "@/app/apiPaths";
import {GetChangesReportsResponse} from "@/pb/api/devplan/services/web/company";
import {jr} from "@/hooks/queries/response-handler";
import {ChangesReport, ResolvedChange, ResolvedPerson} from "@devplaninc/codeup";
import type {TrendsMetrics} from "@/app/components/trends/metrics";

export type TrendsData = {
  metrics: TrendsMetrics | null
  reports: ChangesReport[]
  changes: Record<string, ResolvedChange>
  persons: Record<string, ResolvedPerson>
}

export type TrendsStoreState = {
  trendsData: Record<string, TrendsData>
  fetchTrendsData(companyId: number, timeframe: string): Promise<void>
}

export const createTrendsSlice: StateCreator<
  TrendsStoreState,
  [],
  [],
  TrendsStoreState
> = ((set) => ({
  trendsData: {},
  fetchTrendsData: async (companyId, timeframe) => {
    const url = `${companyTrendsAPI(companyId)}?timeframe=${encodeURIComponent(timeframe)}`
    return fetch(url)
      .then(jr)
      .then(js => {
        const metrics: TrendsMetrics | null = js.metrics ?? null

        const {reportsJson, changesJson, personsJson} = GetChangesReportsResponse.fromJSON(js.changesReports)
        const reports = reportsJson.map(json => ChangesReport.fromJSON(JSON.parse(json)))

        const changes: Record<string, ResolvedChange> = {}
        for (const json of changesJson) {
          const c = ResolvedChange.fromJSON(JSON.parse(json))
          changes[c.changeId] = c
        }

        const persons: Record<string, ResolvedPerson> = {}
        for (const json of personsJson) {
          const p = ResolvedPerson.fromJSON(JSON.parse(json))
          persons[p.personId] = p
        }

        const key = `${companyId}-${timeframe}`
        set(s => ({...s, trendsData: {...s.trendsData, [key]: {metrics, reports, changes, persons}}}))
      })
  },
}))
